
    import './styles.scoped.css';
    export default {
  "button-trigger": "awsui_button-trigger_18eso_16r02_17",
  "arrow": "awsui_arrow_18eso_16r02_17",
  "in-filtering-token-root": "awsui_in-filtering-token-root_18eso_16r02_77",
  "in-filtering-token-nested": "awsui_in-filtering-token-nested_18eso_16r02_77",
  "has-caret": "awsui_has-caret_18eso_16r02_113",
  "placeholder": "awsui_placeholder_18eso_16r02_116",
  "pressed": "awsui_pressed_18eso_16r02_132",
  "disabled": "awsui_disabled_18eso_16r02_138",
  "in-filtering-token": "awsui_in-filtering-token_18eso_16r02_77",
  "readonly": "awsui_readonly_18eso_16r02_159",
  "invalid": "awsui_invalid_18eso_16r02_180",
  "warning": "awsui_warning_18eso_16r02_189",
  "custom-option": "awsui_custom-option_18eso_16r02_198",
  "inline-tokens": "awsui_inline-tokens_18eso_16r02_203",
  "grouped": "awsui_grouped_18eso_16r02_206",
  "grouped-first": "awsui_grouped-first_18eso_16r02_206",
  "grouped-middle": "awsui_grouped-middle_18eso_16r02_212",
  "grouped-last": "awsui_grouped-last_18eso_16r02_218",
  "grouped-only": "awsui_grouped-only_18eso_16r02_224"
};
  